export default function Arrowdown() {
return(
<svg xmlns="http://www.w3.org/2000/svg" width="16" height="62" viewBox="0 0 16 62" fill="none">
  <path d="M7.16985 61.7074C7.56037 62.0979 8.19354 62.0979 8.58406 61.7074L14.948 55.3434C15.3385 54.9529 15.3385 54.3197 14.948 53.9292C14.5575 53.5387 13.9243 53.5387 13.5338 53.9292L7.87696 59.586L2.2201 53.9292C1.82958 53.5387 1.19641 53.5387 0.805888 53.9292C0.415363 54.3197 0.415363 54.9529 0.805888 55.3434L7.16985 61.7074ZM6.87695 0.814941L6.87696 61.0002L8.87696 61.0002L8.87695 0.814941L6.87695 0.814941Z" fill="black"/>
</svg>
)
}
